<template>
  <h4 class="ribbon">{{ ribbonLabel }}</h4>
</template>

<script>
export default {
  name: "Ribbon",
  props: ["ribbonLabel"],
};
</script>

<style>
.ribbon {
  margin: 0;
  padding: 0;
  background: #9a69cb;
  color: white;
  padding: 10px 0;
  position: absolute;
  top: 0;
  right: 0;
  transform: translateX(30%) translateY(0%) rotate(45deg);
  transform-origin: top left;
  font-size: 13px;
}
.ribbon:before,
.ribbon:after {
  content: "";
  position: absolute;
  top: 0;
  margin: 0 -1px; /* tweak */
  width: 100%;
  height: 100%;
  background: #9a69cb;
}
.ribbon:before {
  right: 100%;
}

.ribbon:after {
  left: 100%;
}
</style>
